import React, { Component } from "react";
import PropTypes from "prop-types";
import Achievement from "./Achievement";

const propTypes = {
  items: PropTypes.array.isRequired,
  language: PropTypes.string,
  projectId: PropTypes.number
};

class AchievementsPage extends Component {
  renderItems() {
    const items = this.props.items;
    return items.map((item, index) => (
      <Achievement
        key={item.id}
        id={item.id}
        title={item.name}
        img={item.imageSmall}
        earned={item.earned}
        language={this.props.language}
        projectId={this.props.projectId}
      />
    ));
  }

  render() {
    return (
      <div className="container verticalpadding bottompadding-floating">
        <div className="innerblock pure-g">
          <div className="pure-u-1 pure-u-md-16-24 automargin">
            {this.renderItems()}
          </div>
        </div>
      </div>
    );
  }
}

AchievementsPage.propTypes = propTypes;

export default AchievementsPage;
